import { createContext } from "react";

const getCurrentMonthYear = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // Add leading zero if needed
    return `${year}-${month}`;
  };
        
export const DateRangeContext = createContext(getCurrentMonthYear());